/* global google */
import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

function MapSection() {
  const mapRef = useRef(null);
  const scriptLoaded = useRef(false);

  useEffect(() => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!apiKey) {
      console.error("Google Maps API 키가 설정되지 않았습니다.");
      return;
    }

    if (scriptLoaded.current) return;

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      console.error('Google Maps API 로드 실패');
      scriptLoaded.current = false;
    };
    script.addEventListener('load', initMap);
    document.head.appendChild(script);

    scriptLoaded.current = true;

    return () => {
      if (script) {
        document.head.removeChild(script);
        scriptLoaded.current = false;
      }
    };
  }, []);

  const initMap = () => {
    try {
      const location = { lat: 37.4887055877098, lng: 126.95699555421 };
      
      const map = new google.maps.Map(mapRef.current, {
        center: location,
        zoom: 17,
        styles: [
          {
            featureType: "all",
            elementType: "labels.text.fill",
            stylers: [{ color: "#1A1A1A" }]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#4A6FA5" }]
          },
        ],
      });

      // 표준 Marker 사용
      const marker = new google.maps.Marker({
        map,
        position: location,
        title: '한소망교회',
      });

      // 마커 클릭 이벤트
      marker.addListener('click', () => {
        window.open('https://maps.app.goo.gl/oYbZhzLGqeSnmbnG6', '_blank');
      });
    } catch (error) {
      console.error('Map initialization error:', error);
    }
  };

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-4xl font-title font-bold text-text-navy text-center mb-12"
        >
          오시는 길
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="space-y-6"
          >
            <div className="bg-neutral/20 p-8 rounded-xl shadow-sm">
              <h3 className="text-2xl font-heading font-semibold mb-6">교회 정보</h3>
              <div className="space-y-4 text-lg">
                <p className="flex items-center space-x-3">
                  <span className="text-accent">📍</span>
                  <span>서울특별시 관악구 관악로 37길 17, 한소망교회</span>
                </p>
                <p className="flex items-center space-x-3">
                  <span className="text-accent">📞</span>
                  <a
                    href="tel:02-887-6696"
                    className="hover:text-accent transition-colors font-heading"
                  >
                    02-887-6696
                  </a>
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="h-[400px] rounded-xl overflow-hidden shadow-lg"
          >
            <div ref={mapRef} className="w-full h-full" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default MapSection;